import { useState } from 'react';
import { styled } from 'styled-components';
import TicketingNotice from '../modal/TicketingNotice';
import PersonalInfoUse from '../modal/PersonalInfoUse';

export default function TermsAndConditions({
  noticeChecked,
  setNoticeChecked,
  privacyChecked,
  setPrivacyChecked,
}: {
  noticeChecked: boolean;
  setNoticeChecked: (val: boolean) => void;
  privacyChecked: boolean;
  setPrivacyChecked: (val: boolean) => void;
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentModal, setCurrentModal] = useState<string | null>(null);

  // const [noticeChecked, setNoticeChecked] = useState(false);
  // const [privacyChecked, setPrivacyChecked] = useState(false);

  const openModal = (modalName: string) => {
    setCurrentModal(modalName);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setCurrentModal(null);
  };

  const handleNoticeConfirmed = () => {
    setNoticeChecked(true);
    closeModal();
  };

  const renderModal = () => {
    if (!modalOpen) return null;

    switch (currentModal) {
      case 'TicketingNotice':
        return <TicketingNotice onClose={handleNoticeConfirmed} />;
      case 'PersonalInfoUse':
        return <PersonalInfoUse onClose={closeModal} />;
      default:
        return null;
    }
  };

  return (
    <Container>
      <Box>
        <Label>
          <HiddenCheckbox type="checkbox" checked={noticeChecked} disabled />
          <CustomCheckbox onClick={() => openModal('TicketingNotice')} />
          <Content>
            <ModalOpen onClick={() => openModal('TicketingNotice')}>
              입장권 예매 주의사항
            </ModalOpen>
            을 모두 확인하였으며, 이에 따른 불이익 발생 시 책임은 본인에게
            있음에 동의합니다.
          </Content>
        </Label>
      </Box>
      <Box>
        <Label>
          <HiddenCheckbox
            type="checkbox"
            checked={privacyChecked}
            onChange={e => setPrivacyChecked(e.target.checked)}
          />
          <CustomCheckbox />
          <Content>
            <ModalOpen onClick={() => openModal('PersonalInfoUse')}>
              개인정보 수집 및 활용
            </ModalOpen>
            에 동의합니다.
          </Content>
        </Label>
      </Box>
      {renderModal()}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px auto;
`;

const Box = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Label = styled.label`
  display: flex;
  cursor: pointer;
  width: 280px;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  display: none;
`;

const CustomCheckbox = styled.span`
  width: 20px;
  height: 20px;
  border: 1px solid #001e7c;
  border-radius: 6px;
  background-color: #fff;
  position: relative;
  margin-right: 6px;
  box-sizing: border-box;
  flex-shrink: 0;

  ${Label}:has(${HiddenCheckbox}:checked) &::after {
    content: '';
    position: absolute;
    left: 5px;
    top: 2px;
    width: 6px;
    height: 10px;
    border: 1px solid #001e7c;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

const Content = styled.div`
  color: #333;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.3px;
`;

const ModalOpen = styled.span`
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;
